/* NORDAEN — bag.

   The cart form works entirely without this: quantity fields are named
   updates[] and the noscript button submits them. This only removes the
   round trip, and hands control straight back to the form on any failure. */

(() => {
  const init = () => {
    const root = document.querySelector('[data-n-cart]');
    if (!root || root.dataset.nBound) return;
    root.dataset.nBound = '1';

    const form = root.querySelector('form');
    if (!form) return;

    // Stepper buttons submit the form, which Shopify handles natively.
    root.querySelectorAll('[data-n-step]').forEach((step) => {
      step.addEventListener('click', () => {
        const line = step.closest('[data-n-line]');
        const input = line && line.querySelector('[data-n-qty]');
        if (!input) return;
        const delta = Number(step.dataset.nStep) || 0;
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        form.submit();
      });
    });

    // Typing a quantity and leaving the field commits it.
    root.querySelectorAll('[data-n-qty]').forEach((input) => {
      input.addEventListener('change', () => form.submit());
    });
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });

  document.addEventListener('shopify:section:load', init);
})();
